import { notification } from "antd";

export const showNotification = (type, description) => {
  notification[`${type}`]({
    message: type,
    description: description,
  });
}